import { render, staticRenderFns } from "./ClipboardForms.vue?vue&type=template&id=267850f0"
import script from "./ClipboardForms.vue?vue&type=script&lang=ts"
export * from "./ClipboardForms.vue?vue&type=script&lang=ts"
import style0 from "./ClipboardForms.vue?vue&type=style&index=0&id=267850f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports